import React, { lazy, Suspense, useState, useCallback } from "react";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import Home from "./pages/Home";
import "./styles/index.css";

import RadioPlayer from "./RadioPlayer"; // 👈 IMPORTAR RADIO
import "./styles/radio.css"; // 👈 IMPORTAR ESTILO DE LA RADIO

const Admin = lazy(() => import("./pages/Admin"));
const Calif = lazy(() => import("./pages/Calif"));
const Objet = lazy(() => import("./pages/Objet"));
const Job = lazy(() => import("./pages/Job"));
const Drivep = lazy(() => import("./pages/Drivep"));
const EnVivo = lazy(() => import("./pages/EnVivo"));

const SOCIAL_LINKS = [
  { href: "https://www.facebook.com/lamanchaamarilla/?locale=es_LA", icon: "facebook-f", className: "facebook" },
  { href: "https://x.com/", icon: "x-twitter", className: "x" },
  { href: "https://www.instagram.com/lamanchaamarilla/", icon: "instagram", className: "instagram" },
  { href: "https://www.youtube.com/@lamanchaamarilla", icon: "youtube", className: "youtube" },
  { href: "https://www.tiktok.com/@johnnyrangellma", icon: "tiktok", className: "tiktok" }
];

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  const handleNavigateToSection = useCallback((sectionId) => {
    closeMenu();
    navigate("/");

    requestAnimationFrame(() => {
      const section = document.querySelector(sectionId);
      section?.scrollIntoView({ behavior: "smooth" });
    });
  }, [navigate, closeMenu]);

  return (
    <>
         {/* 👇 RADIO GLOBAL */}
          <RadioPlayer />
          
      <header>
        {/* Top Bar */}
        <div className="top-bar">
          <div className="apps">
            <a href="/" onClick={(event) => event.preventDefault()}>Android App</a> |{" "}
            <a href="/" onClick={(event) => event.preventDefault()}>iOS App</a>
          </div>

          <div className="social-icons">
            {SOCIAL_LINKS.map(({ href, icon }, i) => (
              <a key={i} href={href} target="_blank" rel="noopener noreferrer">
                <i className={`fab fa-${icon}`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Navbar */}
        <nav className="navbar">
          <div className="logo">
            <img src="img/MANCHAAMARILLA.COM.png" alt="Logo" fetchPriority="high" decoding="async" />
          </div>

          <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
            <li>
              <Link to="/" className="menu-link btn btn-link p-0 border-0 text-start" onClick={closeMenu}>
                Inicio
              </Link>
            </li>
            <li>
              <Link to="/envivo" className="menu-link btn btn-link p-0 border-0 text-start" onClick={closeMenu}>
                En vivo
              </Link>
            </li>
            <li>
              <button className="menu-link btn btn-link p-0 border-0 text-start"
                onClick={() => handleNavigateToSection("#servicios")}>
                Servicios
              </button>
            </li>
            <li>
              <button className="menu-link btn btn-link p-0 border-0 text-start"
                onClick={() => handleNavigateToSection("#Sobre-Nosotros")}>
                Sobre Nosotros
              </button>
            </li>
            <li>
              <button className="menu-link btn btn-link p-0 border-0 text-start"
                onClick={() => handleNavigateToSection("#contacto")}>
                Únete
              </button>
            </li>
            <li>
              <Link to="/drivep" className="menu-link btn btn-link p-0 border-0 text-start" onClick={closeMenu}>
                Iniciar sesión
              </Link>
            </li>
          </ul>

          <div className="menu-toggle" onClick={() => setMenuOpen(v => !v)}>
            <i className="fas fa-bars"></i>
          </div>
        </nav>
      </header>

      {/* Main */}
      <main className="containerx">
        <Suspense
          fallback={
            <div className="container py-5 text-center">
              <div className="spinner-border text-warning" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/calf" element={<Calif />} />
            <Route path="/obj" element={<Objet />} />
            <Route path="/job" element={<Job />} />
            <Route path="/drivep" element={<Drivep />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/envivo" element={<EnVivo />} />
          </Routes>
        </Suspense>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 footer-logo text-center mb-4 mb-lg-0">
              <img src="img/taxi.webp" alt="Logo La Mancha Amarilla" className="footer-logo-img" loading="lazy" decoding="async" />
            </div>

            <div className="col-lg-3 col-md-6 footer-about mb-4 mb-lg-0">
              <p>
                La Mancha Amarilla es un proyecto pensado para mejorar el servicio de transporte en taxis,
                fomentando una comunidad cívico-social más humana y confiable.
              </p>
            </div>

            <div className="col-lg-3 col-md-6 footer-contact mb-4 mb-lg-0">
              <h5>Información de Contacto</h5>
              <ul>
                <li><strong>Correo:</strong> LamanchaamarillaVirtual@gmail.com</li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-social">
              <h5>Síguenos</h5>
              <div className="social-grid">
                {SOCIAL_LINKS.map(({ href, icon, className }, i) => (
                  <a key={i} href={href} className={className} target="_blank" rel="noopener noreferrer">
                    <i className={`fab fa-${icon}`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} La Mancha Amarilla. Todos los derechos reservados.</p>
        </div>
      </footer>
    </>
  );
}
